<div class="rich-text-editor-container" [class.preview-mode]="isPreviewMode" #richTextEditorContainer>
  <!-- Preview mode toggle button -->
   <!-- TODO: This still needs to be fixed
  <div class="preview-toggle-container">
    <button 
      type="button"
      class="preview-toggle-btn"
      [class.active]="isPreviewMode"
      (click)="togglePreviewMode()"
      title="Toggle preview mode to see suggestions replaced with examples">
      {{ isPreviewMode ? 'Exit Preview' : 'Preview Mode' }}
    </button>
  </div>
  -->
  
  <!-- Line numbers container -->
  <div 
    #lineNumbersDiv 
    class="line-numbers-container">
  </div>
  
  <!-- Transparent textarea for user input -->
  <textarea 
    #textarea 
    class="rich-text-editor-textarea"
    [class.force-visible]="konamiService.serviceSelected === 'aa_editor'"
    (input)="onTextareaInput()"
    (scroll)="onTextareaScroll()"
    (keydown)="onTextareaKeydown($event)"
    (paste)="onTextareaPaste($event)"
    (focus)="onFocus()"
    (blur)="onBlur()"
    [readonly]="readonly"
    spellcheck="false"
    placeholder="Start writing your script here...&#10;&#10;Examples:&#10;WAITER: Hello, what would you like to order?&#10;CUSTOMER: (Look at the menu)&#10;CUSTOMER: I would like FOOD please!&#10;Meanwhile CHEF: I'll prepare that for you!"></textarea>
  
  <!-- Highlighting div that shows the processed content -->
  <div 
    #highlightDiv 
    class="rich-text-editor-highlight">
  </div>
</div>

<!-- Error and Warning Lists -->
<div class="editor-issues-container" *ngIf="errors.length > 0 || warnings.length > 0">
  <!-- Errors -->
  <div class="errors-section" *ngIf="errors.length > 0">
    <h4 class="errors-title">
      <span class="error-icon">⚠️</span>
      Errors ({{ errors.length }})
    </h4>
    <ul class="errors-list">
      <li *ngFor="let error of errors" class="error-item">
        <span class="error-text">{{ error.text }}</span>
        <span class="error-message">{{ error.tooltip }}</span>
        <span class="error-line" *ngIf="error.line">Line {{ error.line }}</span>
      </li>
    </ul>
  </div>
  
  <!-- Warnings -->
  <div class="warnings-section" *ngIf="warnings.length > 0">
    <h4 class="warnings-title">
      <span class="warning-icon">⚠️</span>
      Warnings ({{ warnings.length }})
    </h4>
    <ul class="warnings-list">
      <li *ngFor="let warning of warnings" class="warning-item">
        <span class="warning-text">{{ warning.text }}</span>
        <span class="warning-message">{{ warning.tooltip }}</span>
        <span class="warning-line" *ngIf="warning.line">Line {{ warning.line }}</span>
      </li>
    </ul>
  </div>
</div> 